import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	flagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	flagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyActionCopied: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	flagTitle: {
		id: 'issue-navigator-actions-common.success-flag.flag-title',
		defaultMessage: '"{name}" filter saved',
		description: 'Title for the flag shown on successful filter save',
	},
	flagDescription: {
		id: 'issue-navigator-actions-common.success-flag.flag-description',
		defaultMessage: 'We’ve saved this filter successfully.',
		description: 'Description for the flag shown on successful filter save',
	},
	viewAction: {
		id: 'issue-navigator-actions-common.success-flag.view-action',
		defaultMessage: 'View filter',
		description: 'Text for the link to view a filter on successful filter save',
	},
	copyAction: {
		id: 'issue-navigator-actions-common.success-flag.copy-action',
		defaultMessage: 'Copy link',
		description: 'Test for the button to copy the filter URL on successful save',
	},
	copyActionCopied: {
		id: 'issue-navigator-actions-common.success-flag.copy-action-copied',
		defaultMessage: 'Copied',
		description: 'Feedback text to user when the link was copied to clipboard successfully',
	},
});
export default messages;
